import React from 'react';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import { ReceiptLineSummary } from './ReceiptLineSummary';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { ExtendStayPreviewRequest, TripAdjustmentPreviewResponse } from 'guest-data-types-ts-lib/types/adjustments';

interface ReceiptLineOccupancyProps {
    preview: TripAdjustmentResponse;
    locale: string;
}

export const ReceiptLineExtendStay: React.FC<ReceiptLineOccupancyProps> = (props) => {
    const { preview, locale } = props;
    const { adjustment, delta } = preview;
    const { additional_nights_count } = (adjustment as ExtendStayPreviewRequest).data;

    const plural = additional_nights_count > 1;
    const text = TranslationUtils.get('payment_form_add_extended_stay', { days: additional_nights_count });
    return (
        <>
            <ReceiptLineSummary
                summaryTitle={plural ? text : text.replace('s', '')}
                summaryValue={CurrencyUtils.formatCurrency(delta.rent, delta.currency)}
                currency={delta.currency}
                locale={locale}
            />
            <hr className={'detail-separator'} />
        </>
    );
};
